import { PointsDeductionClientModelWithLabel } from '../Row'

const getDeductionLabel = (deductions: PointsDeductionClientModelWithLabel[]): string => {
    return deductions.map(deduction => deduction.label).join(', ')
}

export default getDeductionLabel
